import { Flex } from "@chakra-ui/react";
import { motion } from 'framer-motion';
import React, { FC, SyntheticEvent, useRef } from 'react'
import { useStore } from '../store';
import { ReactComponent as CloseSVG } from "../assets/images/close_heavy.svg";
import { Video } from "./Video";
import { ZINDEX_5} from "../data/constants";


const FullPageModal: FC = () => {

  const isGalleryMode = useStore((state) => state["isGalleryMode"]);
  const thumbnails = useStore((state) => state["thumbnails"]);
  const setGalleryMode = useStore((state) => state["setGalleryMode"]);
  const { mediaFile, fullSizeFile, thumbnail } = useStore((state) =>  state["selectedCard"]);
  const imgRef = useRef<HTMLImageElement>(null)
  const { width: imgWidth, height: imgHeight } = thumbnails[fullSizeFile] ?? {}
  const height = imgHeight > imgWidth && !mediaFile ? '100%' : 'auto'
  const width =  mediaFile ? '100%' : 'auto'

  const handleClose = (e: SyntheticEvent<HTMLElement>) => {
    const { tagName } = e.target as HTMLElement
    if(tagName === 'DIV' || tagName === 'path') {
      setGalleryMode(false)
    }
  }

  return (
    <MotionFlex
      position="fixed"
      height="calc(100vh - 100px)"
      width="calc(100vw - 100px)"
      maxWidth={mediaFile ? 1300 : '100%'}
      top="50px"
      left={mediaFile ? "50%" : "50px"}
      zIndex={isGalleryMode ? ZINDEX_5 : -1}
      justifyContent="center"
      alignItems="center"
      animate={{
        opacity: isGalleryMode ? 1 : 0,
        scale: isGalleryMode ? 1 : 0.7,
        y: isGalleryMode ? "0%" : "-10%",
        x:  mediaFile ? '-50%' : 0
      }}
      transition={{
        duration: 0.2
      }}
    >
      <div style={{ position: 'relative', height, width }}>
        <MotionFlex
          position="absolute"
          boxShadow="-6px 20px 20px 1px #13131352"
          top="-20px"
          right="-15px"
          zIndex="11"
          width="35px"
          height="34px"
          cursor="pointer"
          borderRadius="100%"
          pointerEvents="all"
          onPointerUp={handleClose}
        >
          <CloseSVG width="35px" height="37px" />
        </MotionFlex>
        {!mediaFile && (
          <figure>
            <img
              ref={imgRef}
              alt="Moments The Matter"
              src={fullSizeFile}
              style={{
                objectFit: 'contain',
                border: '5px solid white',
                maxHeight: 'calc(100vh - 100px)',
                maxWidth: 'calc(100vw - 100px)',
                margin: '0 auto',
              }}
            />
          </figure>
          )}
        <MotionFlex
          justifyContent="center"
          alignItems="center"
        >
          {mediaFile && <Video media={mediaFile} thumbnail={thumbnail ?? fullSizeFile} />}
        </MotionFlex>
      </div>
    </MotionFlex>
  )
}

const MotionFlex = motion(Flex);

export { FullPageModal }
